"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("core-js/modules/es6.object.keys");
require("core-js/modules/es7.object.values");
require("core-js/modules/es6.set");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _slicedToArray2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/slicedToArray.js"));
var _createForOfIteratorHelper2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/createForOfIteratorHelper.js"));
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.map");
var _toConsumableArray2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.regexp.match");
require("core-js/modules/es6.string.ends-with");
require("core-js/modules/es6.array.sort");
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.string.starts-with");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.regexp.split");
var _bookCargo = _interopRequireDefault(require("./bookCargo"));
var _bookingStatus = _interopRequireDefault(require("./bookingStatus"));
var _bookInfo = _interopRequireDefault(require("./bookInfo"));
var _utils = require("@/utils");
var _acceesorySitc = _interopRequireDefault(require("@/componentsBuz/Accessory/acceesorySitc.vue"));
var _copyBook = _interopRequireDefault(require("./copyBook"));
var _SailSchedule = _interopRequireDefault(require("@/components/SailSchedule"));
var _booking = require("@/api/bookSpace/booking");
var _vuex = require("vuex");
var _consignerInfo = _interopRequireDefault(require("./consignerInfo"));
var _consignerReceiveInfo = _interopRequireDefault(require("./consignerReceiveInfo"));
var _consignerInfoOne = _interopRequireDefault(require("./consignerInfoOne"));
var _consignerInfoTwo = _interopRequireDefault(require("./consignerInfoTwo"));
var _MessageInputText = _interopRequireDefault(require("./MessageInputText.vue"));
var _validate = require("@/utils/validate");
var _chargeInfo = _interopRequireDefault(require("./chargeInfo"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "bookingSpaceDetail",
  components: {
    sailSchedule: _SailSchedule.default,
    acceesorySitc: _acceesorySitc.default,
    copyBook: _copyBook.default,
    bookInfo: _bookInfo.default,
    SailScheduleTemplate: _SailSchedule.default,
    bookingStatus: _bookingStatus.default,
    consignerInfo: _consignerInfo.default,
    consignerReceiveInfo: _consignerReceiveInfo.default,
    consignerInfoOne: _consignerInfoOne.default,
    consignerInfoTwo: _consignerInfoTwo.default,
    bookCargo: _bookCargo.default,
    MessageInputText: _MessageInputText.default,
    chargeInfo: _chargeInfo.default
  },
  data: function data() {
    var _this = this;
    var validateEmail = function validateEmail(rule, value, callback) {
      if (!(0, _validate.validateNull)(value)) {
        if (value.length > 500) {
          callback(new Error(_this.$t('userCenter.userInfo.emailCheckRules1')));
        }
        var array = value.split(";");
        for (var i = 0; i < array.length; i++) {
          if (!/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(array[i])) {
            callback(new Error(_this.$t('userCenter.userInfo.emailCheckRules2')));
          }
        }
        callback();
      } else {
        callback();
      }
    };
    return {
      copyForm: {},
      showDialog: true,
      currentDialogIndex: '',
      dialogContent: '',
      loading: null,
      clickButton: false,
      dataList: [],
      facilityName: '',
      showDisplay: false,
      flag: true,
      isShowDocumentNo: false,
      isOriginTemplate: '',
      templateType: '',
      //是不是从模板过来的
      preLockFlag: null,
      adjustVesselFlag: null,
      copyId: '',
      isDisable: false,
      dialogVisible: false,
      disabledType: false,
      copyVisible: false,
      sailScheduleDialogVisible: false,
      sailScheduleDialogVisibleTemplate: false,
      isDelFirstLoad: true,
      vessNameVoy: '',
      bookingId: '',
      showCargoInfo: false,
      form: {
        etaPol: '',
        priceRemark: '',
        remark: '',
        webBkImoComFiles: [],
        // 是否订舱推广
        singleContainerFlag: 0,
        webBkSocComs: [],
        webBkImoComs: [],
        webBkYardComs: [{
          pickupYard: '',
          returnYard: '',
          pickupDate: ''
        }],
        webFeeItemComs: [],
        webBkDocumentComs: [],
        webBkRoutingComs: [],
        webBkReeferComs: [],
        webBkAkComs: [],
        webBkHgComs: [],
        webBkPreContainerComs: [{
          containerType: '',
          quantity: null,
          cargoTypeCode: '',
          pickupDate: '',
          returnDate: '',
          pickUpDepot: '',
          returnDepot: ''
        }],
        //下货箱信息
        vesselCode: '',
        vesselName: '',
        vesselNameCn: '',
        saillingDate: '',
        eta: '',
        bookingFwdPerson: null,
        bookingFwdTel: null,
        bookingFwdEmail: null,
        actualShipper: '',
        bkNo: '',
        blNo: '',
        bookingType: 1,
        transportationTerms: 'CY-CY',
        paidPalce: '',
        paidType: '',
        etd: '',
        // documentType:'',
        deliveryDocumentMethod: 1,
        wbillNo: '',
        agreementNo: '',
        freeTimeNo: 'NIL',
        stuffType: null,
        expCustomsCargoType: '',
        expCustomsCntrType: null,
        sales: '',
        por: '',
        pol: '',
        pod: '',
        del: '',
        porName: '',
        polName: '',
        podName: '',
        delName: '',
        vipFlag: 0,
        masterBlFlag: 0,
        cargoDesc: '',
        cargoGrossWeight: null,
        cargoNetWeight: null,
        tsFlag: 0,
        dgCheckFlag: 0,
        rfCheckFlag: 0,
        akCheckFlag: 0,
        socCheckFlag: 0,
        hgCheckFlag: 0,
        // packageType:'PKGS', //包装类型
        // packageDesc:'PACKAG(S)',//包装描述
        // cargoQuantity:0,//货物数量
        cargoPackageType: 'PKGS',
        //包装类型
        cargoPackageDesc: 'PACKAGE(S)',
        //包装描述
        cargoQuantity: 0,
        //货物数量
        cargoSize: 0,
        //货物重量
        commodityName: null,
        cargoShippingMark: 'N/M',
        //唛头,
        docCommodity: null,
        hsCode: null,
        hsCodeCn: null,
        hsCodeJp: null,
        webBkCargoComs: [{
          commodityCode: ''
        }],
        webBkCustomerComs: [{
          companyName: null,
          customerName: null,
          customerCode: null,
          customerType: 0,
          webBkCusCatalogComs: []
        }, {
          companyName: null,
          customerName: null,
          customerCode: null,
          customerType: 1,
          webBkCusCatalogComs: []
        }, {
          companyName: null,
          customerName: null,
          customerCode: null,
          customerType: 2,
          webBkCusCatalogComs: []
        }, {
          companyName: null,
          customerName: null,
          customerCode: null,
          customerType: 3,
          webBkCusCatalogComs: []
        }]
      },
      isCopy: '',
      packageDescList: [],
      packageTypeList: [],
      packageTypeListKR: [{
        packageCode: "GT",
        packageName: "GT",
        packageNameCn: "GT"
      }],
      cargoListType: [{
        code: 0,
        name: 'Export'
      }, {
        code: 1,
        name: 'Reshipment'
      }],
      stuffTypeList: [{
        value: 2,
        name: 'CFS'
      }, {
        value: 3,
        name: 'CSL'
      }],
      contactTypeCodeList: [{
        value: 'EM',
        labelZh: 'Email',
        labelEh: 'Email'
      }, {
        value: 'FX',
        labelZh: 'Fax',
        labelEh: 'Fax'
      }, {
        value: 'TE',
        labelZh: 'Tel',
        labelEh: 'Tel'
      }],
      rateBaseList: [{
        value: '0',
        labelZh: '摄氏度',
        labelEh: '摄氏度'
      }, {
        value: '1',
        labelZh: '华氏度',
        labelEh: '华氏度'
      }],
      transportationTermsList: [{
        value: '1',
        labelZh: 'SIMIS主系统基础数据-运输条款',
        labelEh: 'SIMIS main system basic data - Shipping terms'
      }],
      bookingTypeList: [],
      paidTypeList: [{
        value: '0',
        labelEh: 'PP'
      }, {
        value: '1',
        labelEh: 'CC'
      }],
      documentTypeList: [{
        value: '1',
        labelZh: '提单',
        labelEh: 'BILL OF LADING'
      }, {
        value: '2',
        labelZh: '海运提单',
        labelEh: 'SEA WAYBILL'
      }],
      cargoList: [{
        value: '0',
        labelEh: 'Export'
      }, {
        value: '1',
        labelEh: 'Reshipment'
      }],
      containerTypeList: [{
        value: '0',
        labelEh: '20GP'
      }, {
        value: '1',
        labelEh: '40GP'
      }],
      cargoTypeCodeList: [{
        value: '0',
        labelZh: '普通',
        labelEh: 'DRY'
      }, {
        value: '1',
        labelZh: '冻货',
        labelEh: 'REEFER'
      }, {
        value: '2',
        labelZh: '半危',
        labelEh: 'SEMI-HAZ'
      }, {
        value: '3',
        labelZh: '全危',
        labelEh: 'HAZARDOUS'
      }, {
        value: '4',
        labelZh: '单挂衣',
        labelEh: 'HG-1(ONE BAR)'
      }, {
        value: '5',
        labelZh: '双挂衣',
        labelEh: 'HG-1(TWO BARS)'
      }, {
        value: '6',
        labelZh: 'OT-1超高1M内',
        labelEh: 'OT-1(OH WITHIN 1M)'
      }, {
        value: '7',
        labelZh: 'OT-2超高1M外2M内',
        labelEh: 'OT-1(OH 1M TO 2M)'
      }, {
        value: '8',
        labelZh: 'FR-1超宽或超高1M内',
        labelEh: 'FR-1(OH OR OW WITHIN 1M)'
      }, {
        value: '9',
        labelZh: 'FR-2超宽或超高1M内',
        labelEh: 'FR-1(OH AND OW WITHIN 1M)'
      }, {
        value: '10',
        labelZh: 'FR-3超限1M以上',
        labelEh: 'FR-(3OH OR OW MORE THAN 1M)'
      }, {
        value: '11',
        labelZh: '空箱',
        labelEh: 'EMPTY'
      }, {
        value: '12',
        labelZh: '半开门',
        labelEh: 'DOOR OPEN'
      }, {
        value: '13',
        labelZh: '废品',
        labelEh: 'SCRAPS'
      }, {
        value: '14',
        labelZh: 'FR(OW)超高',
        labelEh: 'FR(OW)'
      }, {
        value: '15',
        labelZh: 'FR(FV)超高和超宽',
        labelEh: 'FR(RV)'
      }, {
        value: '16',
        labelZh: 'OT(OH)超高',
        labelEh: 'OT(OH)'
      }, {
        value: '17',
        labelZh: 'FR(OH)超高',
        labelEh: 'FR(OH)'
      }, {
        value: '18',
        labelZh: '废纸',
        labelEh: 'WASTE PARER'
      }, {
        value: '19',
        labelZh: '空箱半危',
        labelEh: 'ENPTY%DG'
      }, {
        value: '20',
        labelZh: 'FR-4[FR超长]',
        labelEh: 'FR-4(OL)'
      }, {
        value: '21',
        labelZh: 'FR-5[FR超长和超宽]',
        labelEh: 'FR-5(OL AND OW)'
      }, {
        value: '22',
        labelZh: 'FR-6[FR超长和超宽超高]',
        labelEh: 'RF-6(OL AND OW AND OH)'
      }, {
        value: '23',
        labelZh: 'FR-7[FR超长和超高]',
        labelEh: 'FR-7(OL AND OH)'
      }],
      pickupYardList: [{
        value: '0',
        labelEh: 'Yard1'
      }, {
        value: '1',
        labelEh: 'Yard2'
      }],
      isSplitList: [{
        value: '0',
        labelEh: 'NO',
        labelZh: '否'
      }, {
        value: '1',
        labelEh: 'YES',
        labelZh: '是'
      }],
      lineTypeList: [{
        value: 0,
        labelEh: 'Feeder',
        labelZh: '支线'
      }, {
        value: 1,
        labelEh: 'Ocean',
        labelZh: '干线'
      }],
      directionList: [{
        value: '0',
        labelEh: 'One Way',
        labelZh: '单程'
      }, {
        value: '1',
        labelEh: 'Two Way',
        labelZh: '双程'
      }],
      fullEmptyTypeList: [{
        value: '0',
        labelEh: 'Full',
        labelZh: '重去重回'
      }, {
        value: '1',
        labelEh: 'Empty',
        labelZh: '重去重回'
      }, {
        value: '2',
        labelEh: 'Empty',
        labelZh: '空去回重'
      }, {
        value: '3',
        labelEh: 'Empty',
        labelZh: '空去回空'
      }],
      containerSizeList: [{
        value: '0',
        labelEh: 'Standard container size',
        labelZh: '标准集装箱尺寸'
      }, {
        value: '1',
        labelEh: 'Non-standard container size',
        labelZh: '非标准集装箱尺寸'
      }],
      fullEmptyTypeListType: [{
        value: 1,
        labelEh: 'Horizontal bar',
        labelZh: '单杠'
      }, {
        value: 2,
        labelEh: 'Parallel bars',
        labelZh: '双杠'
      }],
      navTabList: [{
        name: '基础信息',
        nameEn: 'Basic'
      }, {
        name: '收发通信息',
        nameEn: 'Shipper/Consignee '
      }, {
        name: '货物信息',
        nameEn: 'Cargo'
      }, {
        name: '下货纸箱信息',
        nameEn: 'Precontainer'
      }, {
        name: '其他信息',
        nameEn: 'Other'
      }],
      selectedIndex: 0,
      rules: {
        bkNo: [{
          validator: this.validateBkNo,
          trigger: 'blur'
        }],
        blNo: [{
          validator: this.validateBlNo,
          trigger: 'blur'
        }],
        componentDesc: [{
          required: true,
          trigger: 'blur'
        }],
        containerType: [{
          required: true,
          trigger: 'change'
        }],
        quantity: [{
          required: true,
          trigger: 'blur'
        }],
        cargoTypeCode: [{
          required: true,
          trigger: 'change'
        }],
        tripNumber: [{
          required: true,
          trigger: 'blur'
        }],
        lineType: [{
          required: true,
          trigger: 'change'
        }],
        serviceLineCode: [{
          required: true,
          trigger: 'change'
        }],
        vesselCode: [{
          required: true,
          trigger: 'change'
        }],
        vesselName: [{
          required: true,
          trigger: 'blur'
        }],
        voyageNo: [{
          required: true,
          trigger: 'blur'
        }],
        voyageLeg: [{
          required: true,
          validator: this.validateVoyageLeg,
          trigger: 'blur'
        }],
        portFrom: [{
          required: true,
          trigger: 'change'
        }],
        portTo: [{
          required: true,
          trigger: 'change'
        }],
        classType: [{
          required: true,
          trigger: 'blur'
        }],
        unSeriseNo: [{
          required: true,
          trigger: 'blur'
        }],
        property: [{
          required: true,
          trigger: 'blur'
        }],
        packageType: [{
          required: true,
          trigger: 'change'
        }],
        emergencySeq: [{
          required: true,
          trigger: 'blur'
        }],
        emergencyTelNo: [{
          required: true,
          trigger: 'blur'
        }],
        // imoQuantity: [ { required: true, trigger: 'blur' }],
        grossWeight: [{
          required: true,
          trigger: 'blur'
        }],
        netWeight: [{
          required: true,
          trigger: 'blur'
        }],
        packagingCode: [{
          required: true,
          trigger: 'blur'
        }],
        cargoSize: [{
          required: true,
          trigger: 'blur'
        }],
        hsCodeCn: [{
          required: false,
          max: 8,
          trigger: 'blur'
        }, {
          validator: this.validateHsCodeCn,
          trigger: 'blur'
        }],
        hsCodeJp: [{
          required: false,
          max: 6,
          validator: this.validateHsCodeJp,
          trigger: 'blur'
        }],
        hsCode: [{
          required: false,
          max: 6,
          validator: this.validateHsCode,
          trigger: 'blur'
        }],
        casNo1: [{
          required: true,
          trigger: 'blur'
        }],
        casNo2: [{
          required: true,
          trigger: 'blur'
        }],
        casNo3: [{
          required: true,
          trigger: 'blur'
        }],
        contactName: [{
          required: true,
          trigger: 'blur'
        }],
        contactNumber: [{
          required: true,
          trigger: 'blur'
        }],
        contactTypeCode: [{
          required: true,
          trigger: 'change'
        }],
        //  unit: [ { required: true, trigger: 'blur' }],
        temperature: [{
          required: true,
          trigger: 'blur'
        }, {
          validator: this.validateTemperature,
          trigger: 'blur'
        }],
        akLength: [{
          required: true,
          trigger: 'blur'
        }],
        akWidth: [{
          required: true,
          trigger: 'blur'
        }],
        akHigth: [{
          required: true,
          trigger: 'blur'
        }],
        akGrossWeight: [{
          required: true,
          trigger: 'blur'
        }],
        akNetWeight: [{
          required: true,
          trigger: 'blur'
        }],
        // quantity: [ { required: true, trigger: 'blur' }],
        commodityName: [{
          required: true,
          trigger: 'blur'
        }],
        overFront: [{
          required: true,
          trigger: 'blur'
        }],
        overAfter: [{
          required: true,
          trigger: 'blur'
        }],
        overPortside: [{
          required: true,
          trigger: 'blur'
        }],
        overStarboard: [{
          required: true,
          trigger: 'blur'
        }],
        intakeNum: [{
          required: true,
          trigger: 'blur'
        }, {
          validator: this.validateIntakeNum,
          trigger: 'blur'
        }],
        humidity: [{
          validator: this.validateHumidity,
          trigger: 'blur'
        }],
        overHeight: [{
          required: true,
          trigger: 'blur'
        }],
        direction: [{
          required: true,
          trigger: 'change'
        }],
        contactPerson: [{
          validator: this.validateContactPerson,
          trigger: 'blur'
        }],
        priceRemark: [{
          validator: this.validatePriceRemark,
          trigger: 'blur'
        }],
        //  containerSize: [ { required: true, trigger: 'change' }],
        documentNo: [{
          required: true,
          trigger: 'blur'
        }],
        packageCode: [{
          required: true,
          trigger: 'blur'
        }],
        rateBase: [{
          required: true,
          trigger: 'change'
        }],
        carrier: [{
          required: true,
          trigger: 'blur'
        }],
        packageDesc: [{
          required: true,
          trigger: 'change'
        }],
        cargoDesc: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'blur'
        }],
        cargoGrossWeight: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'blur'
        }, {
          validator: this.validateCargoGrossWeight,
          trigger: 'blur'
        }],
        paidType: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'change'
        }],
        deliveryDocumentMethod: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'change'
        }],
        transportationTerms: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'change'
        }],
        fullEmptyType: [{
          validator: this.validateFullEmptyType,
          trigger: 'change'
        }],
        por: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'change'
        }],
        pol: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'change'
        }],
        pod: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'change'
        }],
        del: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'change'
        }],
        //  bkNo: [ { required: true,  message: this.$t('home.placehold'),trigger: 'blur' }],
        bookingFwdEmail: [{
          required: false,
          validator: validateEmail,
          trigger: 'blur'
        }],
        //  cargoShippingMark:[{required: true,  message: this.$t('home.placehold'),trigger: 'blur' }],
        //  cargoQuantity:[{required: true,  message: this.$t('home.placehold'),trigger: 'blur' }],
        //  cargoGrossWeight:[{required: true,  message: this.$t('home.placehold'),trigger: 'blur' }],
        //  cargoSize: [ { required: true,  message: this.$t('home.placehold'),trigger: 'blur' }],
        cargoPackageType: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'change'
        }],
        cargoPackageDesc: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'change'
        }],
        paidPalce: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'change'
        }],
        wbillNo: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'blur'
        }],
        freeTimeNo: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'blur'
        }]
      },
      bookingStatusList: [],
      chargeTypeInfo: [],
      isShowContent: true,
      isDisableBkNo: false,
      hasBkNoRules: true,
      hasBlNoRules: true,
      pickerOptions: {
        disabledDate: function disabledDate(time) {},
        shortcuts: [{
          text: this.$t('home.newToday'),
          onClick: function onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }]
      }
    };
  },
  watch: {
    // 监听中转信息
    'form.webBkRoutingComs': {
      handler: function handler(newVal, oldVal) {
        var hasMainLine = newVal.some(function (item) {
          return item.lineType === 1;
        });
        if (newVal.length > 0 && !hasMainLine) {
          this.$message.warning(this.$t('home.messageFourOne'));
          return;
        }
        if (newVal.length === 1 || !this.form.tsFlag) {
          this.form.pol = newVal[0].portFrom;
          this.form.polName = newVal[0].portFromName || this.form.polName;
          this.form.pod = newVal[0].portTo;
          this.form.podName = newVal[0].portToName || this.form.podName;
          this.form.por = newVal[0].portFrom;
          this.form.porName = newVal[0].portFromName || this.form.porName;
          this.form.del = newVal[0].portTo;
          this.form.delName = newVal[0].portToName || this.form.delName;
          this.form.vesselCode = newVal[0].vesselCode;
          this.form.vesselName = newVal[0].vesselName;
          this.form.voyageLeg = newVal[0].voyageLeg;
          this.form.serviceLineCode = newVal[0].serviceLineCode;
          this.form.voyageNo = newVal[0].voyageNo;
          this.vessNameVoy = newVal[0].vesselName + ' ' + newVal[0].voyageNo + newVal[0].voyageLeg;
        } else if (newVal.length > 1 && this.form.tsFlag) {
          var polData = newVal.find(function (item) {
            return item.lineType === 1;
          });
          this.form.pol = polData.portFrom;
          this.form.polName = polData.portFromName || this.form.polName;
          this.form.vesselCode = polData.vesselCode;
          this.form.vesselName = polData.vesselName;
          this.form.voyageLeg = polData.voyageLeg;
          this.form.serviceLineCode = polData.serviceLineCode;
          this.form.voyageNo = polData.voyageNo;
          this.vessNameVoy = polData.vesselName + ' ' + polData.voyageNo + polData.voyageLeg;
          var podData = newVal.reduce(function (acc, item) {
            return item.lineType === 1 ? item : acc;
          }, null);
          this.form.pod = podData.portTo;
          this.form.podName = podData.portToName || this.form.podName;
          this.form.por = newVal[0].portFrom;
          this.form.porName = newVal[0].portFromName || this.form.porName;
          this.form.del = newVal[newVal.length - 1].portTo;
          this.form.delName = newVal[newVal.length - 1].portToName || this.form.delName;
        }
      },
      deep: true
    },
    isToastSave: {
      handler: function handler(newVal, oldVal) {
        if (newVal) {
          if (this.handleBeforeRouteLeave()) {
            this.handleCloseDetail();
          } else {
            this.ishandleDelTag();
          }
        }
      },
      immediate: true
    },
    // 'isDisableBkNo':function(newVal){
    //     if(newVal){
    //          this.rules.bkNo = [];
    //          this.$refs.form.clearValidate(['bkNo'])
    //         }else{
    //          this.rules.bkNo = [ { required: true,  message: this.$t('home.placehold'),trigger: 'blur' }]
    //         }
    //     console.log(newVal,'isDisableBkNo')
    // },
    'form.singleContainerFlag': function formSingleContainerFlag(newVal) {
      console.log('myVar changed from', 'to', newVal);
      if (newVal === 1) {
        this.form.webBkPreContainerComs.forEach(function (item) {
          item.quantity = 1;
        });
      }

      // 在这里可以处理变量变化后的逻辑
    },
    'hasBkNoRules': function hasBkNoRules(newVal) {
      if ((0, _validate.validateNull)(this.form.pol)) {
        this.hasBkNoRules = false;
        this.hasBlNoRules = false;
      }
    },
    'form.pol': function formPol(newVal, oldVal) {
      var _this2 = this;
      (0, _booking.autoGeneralBlNo)(this.form.pol).then(function (res) {
        _this2.hasBkNoRules = res.data.bkNoFlag;
        _this2.hasBlNoRules = res.data.blNoFlag;
      });
      console.log(newVal, '111');
      this.queryMethod();
      if (this.form.paidPalce === oldVal) {
        this.form.paidPalce = newVal;
      }
      // this.autoGeneralBlNo()
      this.handleGetSales();
      if (newVal === 'CNSHK' || newVal === 'CNNSA') {
        this.rules.paidPalce = [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'blur'
        }];
        this.$set(this.rules, 'paidType', [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'blur'
        }]);
      } else {
        this.rules.paidPalce = [];
        this.$refs.form.clearValidate(['paidPalce']);
      }
      if (newVal && newVal.startsWith('KR')) {
        // this.rules.documentNo = [{ required: true,  message: this.$t('home.placehold'),trigger: 'blur' }];
        this.$set(this.rules, 'documentNo', [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'blur'
        }]);
        this.$set(this.rules, 'remark', [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'blur'
        }]);
        // this.$set(this.rules, 'hsCode', [{ required: true,  message: this.$t('home.placehold'),trigger: 'blur' }]);
        // this.$set(this.rules, 'hsCodeCn', [{ required: true,  message: this.$t('home.placehold'),trigger: 'blur' }]);
        // this.$set(this.rules, 'hsCodeJp', [{ required: true,  message: this.$t('home.placehold'),trigger: 'blur' }]);
        this.isShowDocumentNo = true;
      } else {
        this.isShowDocumentNo = false;
      }
      if (newVal && newVal.startsWith('TH')) {
        this.$set(this.rules, 'actualShipper', [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'blur'
        }]);
      } else {
        this.rules.actualShipper = [];
        this.$refs.form.clearValidate(['actualShipper']);
      }
      if (newVal === 'CNTAO') {
        console.log(newVal, '113331', this.form.pol);
      }
    },
    'form.deliveryDocumentMethod': {
      handler: function handler(newVal) {
        if (newVal === 2) {
          this.$set(this.rules, 'wbillNo', [{
            required: true,
            message: this.$t('home.placehold'),
            trigger: 'blur'
          }]);
        } else {
          this.form.wbillNo = '';
          this.rules.wbillNo = [];
          this.$refs.form.clearValidate(['wbillNo']);
        }
      },
      immediate: true // 立即执行一次监听器
    },
    'form.status': {
      handler: function handler(newVal) {
        var _this3 = this;
        if ((newVal === null || newVal === undefined) && !(0, _validate.validateNull)(this.form.pol)) {
          (0, _booking.autoGeneralBlNo)(this.form.pol).then(function (res) {
            _this3.hasBkNoRules = res.data.bkNoFlag;
            _this3.hasBlNoRules = res.data.blNoFlag;
          });
        } else {
          this.hasBkNoRules = true;
          this.hasBlNoRules = true;
        }
      },
      immediate: true // 立即执行一次监听器
    },
    'form.etd': {
      handler: function handler(newVal) {
        var _this4 = this;
        if (this.form.agreementNo !== '' && this.form.agreementNo !== null) {
          var data = {
            por: this.form.por,
            del: this.form.del,
            agreementNo: this.form.agreementNo,
            etd: this.form.etd
          };
          (0, _booking.getFreeTimeNo)(data).then(function (res) {
            if (res.data === 'NIL') {
              if ((0, _validate.validateNull)(_this4.form.freeTimeNo)) {
                _this4.form.freeTimeNo = res.data;
              }
            } else {
              _this4.form.freeTimeNo = res.data;
            }
            console.log(newVal, 'ft', _this4.form.freeTimeNo);
          });
        }
      },
      deep: true
    },
    'form.agreementNo': {
      handler: function handler(newVal) {
        var _this5 = this;
        if (newVal !== '' && newVal !== null) {
          var data = {
            por: this.form.por,
            del: this.form.del,
            agreementNo: newVal,
            etd: this.form.etd
          };
          (0, _booking.getFreeTimeNo)(data).then(function (res) {
            if (res.data === 'NIL') {
              if ((0, _validate.validateNull)(_this5.form.freeTimeNo)) {
                _this5.form.freeTimeNo = res.data;
              }
            } else {
              _this5.form.freeTimeNo = res.data;
            }
            console.log(newVal, 'ft', _this5.form.freeTimeNo);
          });
        }
      },
      deep: true
    },
    'form.del': {
      handler: function handler(newVal, oldVal) {
        if (this.isDelFirstLoad) {
          this.isDelFirstLoad = false;
          return;
        }
        if (this.form.paidType === 1 && newVal !== '') {
          this.form.paidPalce = this.form.del;
        }
      },
      deep: true
    }
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language', 'userInfo', 'isToastSave', 'isToastSavePath'])), {}, {
    isCanSave: function isCanSave() {
      var status = this.form.status;
      if (status === '10' || status === '11' || status === '0' || status === '1' || status === '5' || status === '8' || status === '9' || status === '2' || status == null) {
        return true;
      }
      return false;
    },
    isCanSaveDraft: function isCanSaveDraft() {
      var status = this.form.status;
      if (status === '10' || status == null) {
        return true;
      }
      return false;
    },
    isCanSaveCopy: function isCanSaveCopy() {
      var status = this.form.status;
      if (status === '13' || status == null || status === '14' || status === '4' || status === '5') {
        return false;
      }
      return true;
    },
    total: function total() {
      return this.form.webBkPreContainerComs.filter(function (item) {
        return item.containerType && item.quantity;
      }) // 过滤掉 containerType 和 quantity 为空或无效的项
      .map(function (item) {
        return "".concat(item.containerType, "*").concat(item.quantity);
      }) // 对剩余的项进行拼接
      .join(';'); // 用分号连接所有项
    },
    /**
     * @return {boolean}
     */
    CNXMNDisabled: function CNXMNDisabled() {
      return this.form.pol === 'CNXMN' && this.form.preLock === 1;
    }
  }),
  mounted: function mounted() {
    var _this6 = this;
    this.$dictionary.get(['DELIVERY_DOCMENT_METHOD', 'BOOKING_WEB_STATUS_COM', 'DOC_SOCRETURN', 'SOC_CONTAINER_SIZE', 'MKT_SOC_FULL_EMPTY', 'DOC_DG_DIVISION_PACKAGING_GROUP', 'BOOKINGTYPE', 'CDM_SERVICE_MODE', 'PAID_TYPE'], true).then(function (res) {
      res = JSON.parse(JSON.stringify(res));
      console.log(res, 'res');
      _this6.bookingTypeList = res.BOOKINGTYPE;
      _this6.vesselTypeList = res.CDM_SERVICE_MODE;
      _this6.paidTypeList = res.PAID_TYPE;
      _this6.packageDescList = res.DOC_DG_DIVISION_PACKAGING_GROUP;
      _this6.containerSizeList = res.SOC_CONTAINER_SIZE;
      _this6.fullEmptyTypeList = res.MKT_SOC_FULL_EMPTY;
      _this6.directionList = res.DOC_SOCRETURN;
      _this6.bookingStatusList = res.BOOKING_WEB_STATUS_COM ? res.BOOKING_WEB_STATUS_COM : [];
      _this6.documentTypeList = res.DELIVERY_DOCMENT_METHOD ? res.DELIVERY_DOCMENT_METHOD : [];
      // soc
    });
    this.bookingInfo = this.$route.query.bookingInfo && JSON.parse(this.$route.query.bookingInfo);
    this.chargeInfo = this.$route.query.chargeDetails && JSON.parse(this.$route.query.chargeDetails);
    this.bookingId = this.$route.query.id;
    this.isDisable = this.$route.query.type === 'Look' || false;
    this.isOriginTemplate = this.$route.query.templateType || null;
    this.isCopy = this.$route.query.type || null; //从拷贝过来的
    console.log(this.isCopy, this.$route.query.bookingInfo, '88888', this.bookingId, this.isOriginTemplate);
    console.log(this.userInfo, 'userInfo');
    this.isDelFirstLoad = true;
    if (this.bookingId && !this.isOriginTemplate) {
      this.bookingHeadWebInitProps();
    } else if (this.bookingId && this.isOriginTemplate) {
      this.oldData = JSON.parse(JSON.stringify(this.form)); //用来对于是否被更改
      this.showCargoInfo = true; //防止一些界面显示不出来，兜底设置为true
      this.getMyTemplate();
    } else if (this.isCopy === 'copy') {
      this.bookingHeadWebInitProps();
    } else {
      this.oldData = JSON.parse(JSON.stringify(this.form)); //用来对于是否被更改
      this.$refs.form.resetFields();
      this.handleInit();
      console.log(this.form, 'this.form88888888---');
    }
    // this.$refs.acceesorySitc.dialogVisible = true
    this.queryListPackageType();
    if (this.isCopy !== 'copy') {
      this.getFlagVoyageAdjust();
    }
    if (this.isDisable) {
      this.showDisplay = true;
    }
    if ((0, _validate.validateNull)(this.form.pol)) {
      this.hasBkNoRules = false;
      this.hasBlNoRules = false;
    }
  },
  activated: function activated() {},
  beforeDestroy: function beforeDestroy() {
    this.chargeTypeInfo = [];
    this.chargeInfo = null;
    this.bookingInfo = null;
    this.bookingId = null;
  },
  formInit: function formInit() {},
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    console.log(this.action, this.action !== 'action', 'action');
    if (this.action !== 'cancel' && this.handleBeforeRouteLeave()) {
      this.handleCloseDetail();
    } else {
      next();
    }
  },
  methods: {
    validateNull: _validate.validateNull,
    // 打开提示框
    openDialog: function openDialog(item, index, biteLength) {
      this.showDialog = true;
      this.dialogContent = item;
      this.currentDialogIndex = index;
      this.$refs.myDialog.openDialog(biteLength);
    },
    //为了关闭弹出框之后重新渲染，不然限制字节长度的属性会延迟挂载。
    confirmClose: function confirmClose() {
      var _this7 = this;
      this.showDialog = false;
      setTimeout(function () {
        _this7.showDialog = true;
      }, 10);
    },
    // 提交
    confirm: function confirm(inpText) {
      if (this.currentDialogIndex === 3) {
        this.form.remark = inpText;
      } else if (this.currentDialogIndex === 4) {
        this.form.priceRemark = inpText;
      } else if (this.currentDialogIndex === 1) {
        this.form.cargoDesc = inpText;
      } else if (this.currentDialogIndex === 2) {
        this.form.cargoShippingMark = inpText;
      }
      this.showDialog = false;
    },
    queryMethod: function queryMethod() {
      var _this8 = this;
      var data = {
        currentPage: 1,
        pageSize: 1000,
        portCode: this.form.pol
      };
      (0, _booking.queryListPortFacility)(data).then(function (res) {
        _this8.dataList = res.data.records || [];
      });
    },
    changePickupYard: function changePickupYard(index) {
      this.pickupYardIndex = index;
    },
    handlePickupYard: function handlePickupYard(val) {
      var data = this.form.webBkYardComs[this.pickupYardIndex];
      data.returnYard = data.pickupYard;
    },
    // 处理收法通信息
    handleInfoShou: function handleInfoShou(data) {
      // 数组 a
      var a = [0, 1, 2, 3];
      // 遍历数组 a
      a.forEach(function (type) {
        // 查找是否存在对应的 customerType
        var exists = data.some(function (item) {
          return item.customerType === type;
        });
        // 如果不存在，添加新的对象
        if (!exists) {
          data.push({
            companyName: null,
            customerName: null,
            customerCode: null,
            customerType: type,
            webBkCusCatalogComs: []
          });
        }
      });
      // 按 customerType 排序
      return data.sort(function (a, b) {
        return a.customerType - b.customerType;
      });
    },
    generateAndSortArray: function generateAndSortArray(webBkCusCatalogComs, sequence) {
      var result = [];
      sequence.forEach(function (seq) {
        var found = webBkCusCatalogComs.find(function (item) {
          return item.sequence === seq;
        });
        if (found) {
          result.push(found);
        } else {
          var newObj = {
            catalogContent: '',
            bkCusCatalogWebComId: null,
            bkCustomerWebComId: null,
            sequence: seq,
            printOrder: seq
          }; // Default values assumed based on the example
          result.push(newObj);
        }
      });
      return result;
    },
    // 处理收法通的信息
    handleSetMessage: function handleSetMessage() {
      var _this9 = this;
      this.form.webBkCustomerComs = this.handleInfoShou(this.form.webBkCustomerComs);
      var sequence = ['1', '2', '7', '8', '10', '9', '15', '16', '3', '5', '6', '99', '11', '12', '13', '14'];
      this.form.webBkCustomerComs.forEach(function (item) {
        item.webBkCusCatalogComs = _this9.generateAndSortArray(item.webBkCusCatalogComs, sequence);
      });
    },
    handleShowDisplay: function handleShowDisplay() {
      if (this.form.pol && this.form.pol.startsWith('TH')) {
        this.showDisplay = true;
      } else {
        this.showDisplay = !this.showDisplay;
      }
    },
    autoGeneralBlNo: function autoGeneralBlNo() {
      var _this10 = this;
      if (!this.form.bookingId && this.form.pol) {
        (0, _booking.autoGeneralBlNo)(this.form.pol).then(function (res) {
          _this10.isDisableBkNo = res.data;
          console.log(res.data, '判断有没有订舱号出号');
          res.data && _this10.form.bkNo === null;
        });
      } else {
        this.isDisableBkNo = false;
      }
    },
    handleCloseLast: function handleCloseLast() {
      if (this.handleBeforeRouteLeave()) {
        this.handleCloseDetail();
      } else {
        this.ishandleDelTag();
      }
    },
    handleBeforeRouteLeave: function handleBeforeRouteLeave() {
      var data = {
        newData: this.newData || this.form,
        oldData: this.oldData
      };
      delete data.oldData.sales;
      delete data.newData.sales;
      var newFormString = JSON.stringify(data.newData);
      var oldFormString = JSON.stringify(data.oldData);
      if (oldFormString !== newFormString) {
        return true;
      } else {
        return false;
      }
    },
    // validateHsCodeJp(rule, value, callback) {
    //   if(this.form.webBkRoutingComs.some(item=>item.portTo.startsWith('JP'))&&validateNull(value)){
    //     callback(new Error(this.$t("home.hsCodeJpNotNull")));
    //   } else {
    //     callback();
    //   }
    // },
    //  validateHsCode(rule, value, callback) {
    //    if(this.form.webBkRoutingComs.some(item=>item.portFrom.startsWith('KR'))&&validateNull(value)){
    //      callback(new Error(this.$t("home.hsCodeNotNull")));
    //    } else {
    //      callback();
    //    }
    //  },
    validateBkNo: function validateBkNo(rule, value, callback) {
      if (!this.hasBkNoRules && (0, _validate.validateNull)(value)) {
        callback(new Error(this.$t("home.toast2")));
      } else {
        callback();
      }
    },
    validateBlNo: function validateBlNo(rule, value, callback) {
      if (!this.hasBlNoRules && (0, _validate.validateNull)(value)) {
        callback(new Error(this.$t("home.toast3")));
      } else {
        callback();
      }
    },
    validatePriceRemark: function validatePriceRemark(rule, value, callback) {
      if (this.form.pol && (this.form.pol === 'CNSHK' || this.form.pol === 'CNNSA') && (0, _validate.validateNull)(value)) {
        callback(new Error(this.$t("home.priceRemarkInfo")));
      } else {
        callback();
      }
    },
    validateContactPerson: function validateContactPerson(rule, value, callback) {
      if (this.form.pol && this.form.pol.startsWith('TH') && (0, _validate.validateNull)(value)) {
        callback(new Error());
      } else {
        callback();
      }
    },
    validateHsCodeCn: function validateHsCodeCn(rule, value, callback) {
      if (this.form.pol && this.form.pol.startsWith('MY') && !this.form.hsCodeCn) {
        callback(new Error(this.$t('home.hsCodeFour')));
      } else {
        callback();
      }
    },
    validateHsCodeJp: function validateHsCodeJp(rule, value, callback) {
      if (!(0, _validate.validateNull)(value) && !/^\d{6}$/.test(value)) {
        callback(new Error(this.$t('home.hsCodeJpNotNum6')));
      } else {
        callback();
      }
    },
    validateHsCode: function validateHsCode(rule, value, callback) {
      if (!(0, _validate.validateNull)(value) && !/^\d{6}$/.test(value)) {
        callback(new Error(this.$t('home.hsCodeKrNotNum6')));
      } else {
        callback();
      }
    },
    validateTemperature: function validateTemperature(rule, value, callback) {
      var reg = /^[-+]?(0|([1-9][0-9]*))(\.[\d]{1,2})?$/;
      var flag = reg.test(value);
      if (flag) {
        callback();
      } else {
        this.$message.warning(this.$t("home.validateTemperature"));
        callback(new Error('temperature'));
      }
    },
    validateIntakeNum: function validateIntakeNum(rule, value, callback) {
      console.log(value, 'value');
      if (['%', 'CBM/H', 'CLOSED'].some(function (suffix) {
        return value.endsWith(suffix);
      })) {
        callback();
      } else {
        this.$message.warning(this.$t("home.validateIntakeNum"));
        callback(new Error('99'));
      }
    },
    validateHumidity: function validateHumidity(rule, value, callback) {
      if (!(0, _validate.validateNull)(value)) {
        if (['%'].some(function (suffix) {
          return value.endsWith(suffix);
        })) {
          callback();
        } else {
          this.$message.warning(this.$t("home.validateHumidity"));
          callback(new Error('99'));
        }
      } else {
        callback();
      }
    },
    validateFullEmptyType: function validateFullEmptyType(rule, value, callback) {
      if (this.$refs.bookInfo.initDirection === 0) {
        callback();
      } else {
        if (value === '' || value === null) {
          callback(new Error(this.$t('home.placehold')));
        } else {
          callback();
        }
      }
    },
    validateCargoGrossWeight: function validateCargoGrossWeight(rule, value, callback) {
      var _this11 = this;
      if (value === 0) {
        if (this.form.bookingType !== 2 && !this.form.webBkPreContainerComs.some(function (item) {
          return item.cargoTypeCode === '0014';
        })) {
          this.$confirm(this.$t('home.checkCargoGrossWeight1'), this.$t('confirmMsg.title'), {
            confirmButtonText: this.$t('confirmMsg.confirm'),
            cancelButtonText: this.$t('confirmMsg.cancel'),
            type: 'warning'
          }).then(function () {
            callback(new Error(_this11.$t('home.checkCargoGrossWeight1')));
          });
        } else {
          callback();
        }
      } else {
        if (this.form.bookingType === 2 || this.form.webBkPreContainerComs.some(function (item) {
          return item.cargoTypeCode === '0014';
        })) {
          this.$confirm(this.$t('home.checkCargoGrossWeight2'), this.$t('confirmMsg.title'), {
            confirmButtonText: this.$t('confirmMsg.confirm'),
            cancelButtonText: this.$t('confirmMsg.cancel'),
            type: 'warning'
          }).then(function () {
            callback();
          });
        } else {
          callback();
        }
      }
    },
    validateVoyageLeg: function validateVoyageLeg(rule, value, callback) {
      var _rule$field$match;
      console.log("\u6821\u9A8C\u5B57\u6BB5\uFF1A".concat(rule.field, "\uFF0C\u5F53\u524D\u503C\uFF1A").concat(value));
      var index = (_rule$field$match = rule.field.match(/webBkRoutingComs\.(\d+)\.voyageLeg/)) === null || _rule$field$match === void 0 ? void 0 : _rule$field$match[1];
      if (index === undefined) {
        callback(new Error("无法获取当前行索引"));
      }
      var currentRow = this.form.webBkRoutingComs[index];
      if (currentRow.lineType === 1 && !value) {
        callback(new Error(""));
      } else {
        callback();
      }
    },
    parseTime: _utils.parseTime,
    changePor: function changePor(vel, row) {
      console.log(vel, 'vel', row);
      this.form.porName = row.portName;
    },
    changeDel: function changeDel(vel, row) {
      this.form.delName = row.portName;
    },
    handleSelectVessel: function handleSelectVessel() {
      this.sailScheduleDialogVisible = true;
      console.log('handleSelectVessel', this.sailScheduleDialogVisible);
    },
    changeReturnToPort: function changeReturnToPort(item, selectedRows) {
      this.form.webBkSocComs[this.currentIndex].returnToPortName = selectedRows.portNameCn;
    },
    handleGetIndex: function handleGetIndex(index) {
      this.currentIndex = index;
      console.log(index, '8889998');
    },
    handlePaidTypeChange: function handlePaidTypeChange(newVal) {
      if (newVal === 0) {
        this.form.paidPalce = this.form.pol;
      }
      if (newVal === 1) {
        this.form.paidPalce = this.form.del;
      }
    },
    handleCloseDetail: function handleCloseDetail() {
      var _this12 = this;
      this.$confirm(this.$t('home.closeWaring'), this.$t('confirmMsg.title'), {
        confirmButtonText: this.$t('home.buttonAdd'),
        cancelButtonText: this.$t('home.closeWaringTwo'),
        type: 'warning',
        distinguishCancelAndClose: true
      }).then(function () {
        _this12.handleSave(11);
        //除了蛇口南沙，港口都是保存直接关闭页面，这两个切换的时候需要关闭一下页面
        if (_this12.form.pol === 'CNSHK' || _this12.form.pol === 'CNNSA') {
          _this12.clickButton = true;
        }
      }).catch(function (action) {
        console.log(action, 'action');
        _this12.action = action;
        if (action === 'close') {} else {
          _this12.ishandleDelTag();
        }
      });
    },
    ishandleDelTag: function ishandleDelTag() {
      var data = {
        view: this.isToastSavePath || this.$route
      };
      console.log(data, 'this.$route333------');
      this.$store.dispatch('tagsView/detailTabDelete', data);
      this.$store.dispatch("isSaveTip/isToastSave", false);
    },
    delTag: function delTag(view) {
      this.$store.dispatch('tagsView/delView', view).then(function (_ref) {
        var visitedViews = _ref.visitedViews;
      });
    },
    //查看模板明细
    getMyTemplate: function getMyTemplate() {
      var _this13 = this;
      (0, _booking.getMyTemplate)(this.bookingId).then(function (res) {
        _this13.isShowContent = false;
        res.data.webBkImoComs = res.data.webBkCargoComs.length && res.data.webBkCargoComs[0].webBkImoComs || [];
        res.data.webBkReeferComs = res.data.webBkCargoComs.length && res.data.webBkCargoComs[0].webBkReeferComs || [];
        res.data.webBkDocumentComs = [];
        _this13.form = res.data;
        _this13.form.bkNo = null;
        _this13.form.porName = res.data.webBkExtendComs.length && res.data.webBkExtendComs[0].porName;
        _this13.form.delName = res.data.webBkExtendComs.length && res.data.webBkExtendComs[0].delName;
        _this13.handleSetMessage();
        _this13.handleSetDelteList();
        _this13.handleInit();
        _this13.oldData = JSON.parse(JSON.stringify(_this13.form)); //用来对于是否被更改
      });
    },
    // 查看订舱明细
    bookingHeadWebInitProps: function bookingHeadWebInitProps() {
      var _this14 = this;
      (0, _booking.bookingHeadWebInitProps)(this.bookingId).then(function (res) {
        if (res.success) {
          if (_this14.isCopy === 'copy') {
            // 处理危险品和冷箱的id为null
            res.data.webBkCargoComs[0].webBkImoComs.length && res.data.webBkCargoComs[0].webBkImoComs.forEach(function (item) {
              item.bkCargoWebComId = null;
              item.bkImoWebComId = null;
            });
            res.data.webBkCargoComs[0].webBkReeferComs.length && res.data.webBkCargoComs[0].webBkReeferComs.forEach(function (item) {
              item.bkCargoWebComId = null;
              item.bkReeferWebComId = null;
            });
            var objStr = JSON.stringify(res.data);
            var objStrNew = objStr.replace(/"[^"]*WebComId"\s*:\s*[^,}]+/g, function (match) {
              return match.replace(/:\s*[^,}]+/, ':null');
            });
            _this14.form = JSON.parse(objStrNew);
            _this14.form.webBkUploadFiless = [];
            _this14.form.webBkRoutingComs = [];
            _this14.form.webBkContainerComs = [];
            _this14.form.formVgm = [];
            _this14.form.status = null;
            _this14.form.blNo = null;
            _this14.form.bkNo = null;
            _this14.form.topBl = null;
            if (_this14.form.pol == "CNSHK" || _this14.form.pol == "CNYPG" || _this14.form.pol == "CNNSA") {
              _this14.form.hsCodeCn = null;
              _this14.form.hsCodeJp = null;
              _this14.form.hsCode = null;
            }
            _this14.form.bookingType2 = 4;
            _this14.form.blNoType = 2;
            _this14.form.separateType = 0;
            _this14.form.freeTimeNo = 'NIL';
            _this14.form.saillingDate = '';
            _this14.form.eta = '';
            _this14.form.bookingImportFlag = null;
            _this14.form.tsFlag = 0;
            if (_this14.form.pol == "CNYNT" || _this14.form.pol == "CNTXG") {} else {
              _this14.form.vesselName = null;
              _this14.form.vesselCode = null;
              _this14.form.voyageNo = null;
              _this14.form.voyageLeg = null;
              _this14.vessNameVoy = null;
            }
            //泰国单独处理单证类型、海运单协议号
            if (_this14.form.pol.startsWith('TH')) {
              _this14.form.deliveryDocumentMethod = 1;
              _this14.form.wbillNo = '';
            }
            //泰国的单独处理船开前协议号agreementNo
            if (_this14.form.pol.startsWith('TH')) {
              _this14.form.agreementNo = '';
            } else {
              (0, _booking.getAgreementNoFlag)(res.data.agreementNo).then(function (res) {
                if (!res.data) {
                  _this14.form.agreementNo = '';
                }
              });
            }
            _this14.form.webBkChargeDetailComs = [];
            _this14.form.webBkExtendComs[0].singleContainerFlag = 0;
            _this14.form.webBkExtendComs[0].singleFlag = null;
            _this14.form.webBkExtendComs[0].maxTeusLimit = null;
            console.log(objStrNew, 'this.form000000000000000000000');
            console.log(_this14.form, 'this.form000000000000000000000');
          } else {
            _this14.form = res.data;
            _this14.form.webBkChargeDetailComs = (0, _validate.validateNull)(_this14.form.webBkChargeDetailComs) ? [] : _this14.form.webBkChargeDetailComs.filter(function (item) {
              return item.containerType === '20GP' || item.containerType === '40GP' || item.containerType === '40HC';
            });
            if (!(0, _validate.validateNull)(_this14.form.webBkChargeDetailComs)) {
              _this14.navTabList.push({
                name: '运价信息',
                nameEn: 'Freight rate'
              });
            }
            // 预配锁
            if (_this14.form.preLock === '1' || _this14.form.preLock === 1) {
              _this14.preLockFlag = true;
            } else {
              _this14.preLockFlag = null;
            }
          }
          _this14.showCargoInfo = true;
          _this14.isShowContent = false;
          _this14.form.porName = _this14.form.webBkExtendComs[0].porName;
          _this14.form.polName = _this14.form.webBkExtendComs[0].polName;
          _this14.form.podName = _this14.form.webBkExtendComs[0].podName;
          _this14.form.delName = _this14.form.webBkExtendComs[0].delName;
          _this14.vessNameVoy = _this14.form.vesselName && _this14.form.vesselName + ' ' + _this14.form.voyageNo + _this14.form.voyageLeg;
          if (_this14.form.stuffType === 1) {
            _this14.form.stuffType = null;
          }
          // 处理订舱人表结构的问题
          _this14.$set(_this14.form, 'bookingFwdPerson', res.data.webBkExtendComs[0].bookingFwdPerson);
          _this14.$set(_this14.form, 'bookingFwdTel', res.data.webBkExtendComs[0].bookingFwdTel);
          _this14.$set(_this14.form, 'bookingFwdEmail', res.data.webBkExtendComs[0].bookingFwdEmail);

          // 处理冷箱和危险品表结构的问题
          // this.form.webBkImoComs = res.data.webBkCargoComs[0].webBkImoComs || []
          // this.form.webBkReeferComs = res.data.webBkCargoComs[0].webBkReeferComs || []
          _this14.$set(_this14.form, 'webBkImoComs', res.data.webBkCargoComs[0].webBkImoComs);
          _this14.$set(_this14.form, 'webBkReeferComs', res.data.webBkCargoComs[0].webBkReeferComs);
          if (_this14.form.webBkYardComs.length == 0) {
            _this14.form.webBkYardComs = [{
              pickupYard: '',
              returnYard: '',
              pickupDate: ''
            }];
          }
          console.log(_this14.form, 'this.form----------');
          _this14.handleSetMessage();
          _this14.handleGetSales();
          _this14.handleSetDelteList();
        }
        if (_this14.form.pol && _this14.form.pol.startsWith('TH')) {
          _this14.handleShowDisplay();
        }
        setTimeout(function () {
          _this14.oldData = JSON.parse(JSON.stringify(_this14.form)); //用来对于是否被更改
          _this14.newData = _this14.form; //用来对于是否被更改
          if (_this14.clickButton) {
            _this14.ishandleDelTag();
            _this14.clickButton = false;
          }
        }, 10);
        // this.oldData = JSON.parse(JSON.stringify(this.form))//用来对于是否被更改
        // this.newData = this.form//用来对于是否被更改
        // if(this.clickButton){
        //   this.ishandleDelTag()
        //   this.clickButton = false
        // }
      });
    },
    handleGetSales: function handleGetSales() {
      var _this15 = this;
      //  获取业务员
      var data = {
        accountNo: this.userInfo.accountNo,
        pordCode: this.form.pol
      };
      if (this.form.pol && this.form.pol.startsWith('TH') && !(0, _validate.validateNull)(this.form.sales)) {} else {
        (0, _booking.getSaleByAccountNo)(data).then(function (res) {
          _this15.form.sales = res.data;
        });
      }
      //从订舱新增时由于pol还没初始化，触发不了方法，等获取到了pol再触发一下获取出号规则方法
      if (this.form.status === undefined) {
        (0, _booking.autoGeneralBlNo)(this.form.pol).then(function (res) {
          _this15.hasBkNoRules = res.data.bkNoFlag;
          _this15.hasBlNoRules = res.data.blNoFlag;
        });
      }
    },
    selectionChangeTemplate: function selectionChangeTemplate(row) {
      this.sailScheduleDialogVisible = false;
      console.log(row, 'row', '9999');
      this.form.vesselCode = row.vesselCode;
      this.form.vesselName = row.vesselName;
      this.form.voyageNo = row.voyageNo;
      this.form.voyageLeg = row.voyageLeg;
      this.vessNameVoy = row.vesselName + ' ' + row.voyageNo + row.voyageLeg;
      this.form.serviceLineCode = row.serviceLineCode;
      this.form.pol = row.polHidden;
      this.form.pod = row.podHidden;
      this.form.polName = row.pol;
      this.form.podName = row.pod;
      if (this.isCopy === 'copy') {
        this.bookingInfo = row;
        this.handleTransferNew();
      }
    },
    selectionChange: function selectionChange(row, chargeDetails) {
      var _this16 = this;
      this.sailScheduleDialogVisible = false;
      this.loading = (0, _utils.load)();
      this.form.saillingDate = row.polEtdStr;
      this.form.etd = row.polEtdStr;
      this.form.eta = row.podEtaStr;
      //  this.form.vesselCode = row.vesselCode
      //  this.form.vesselName = row.vesselName
      //  this.form.voyageNo = row.voyageNo
      //  this.form.voyageLeg = row.voyageLeg
      //  this.vessNameVoy = row.vesselCode + '.' + row.voyageNo + ' ' +  row.voyageLeg
      //  this.form.serviceLineCode = row.serviceLineCode
      this.form.singleContainerFlag = row.singleContainerFlag;
      console.log(row, this.form.singleContainerFlag, '99339888889');
      if (row.routeList && row.routeList.length > 0) {
        this.form.tsFlag = 1;
        this.form.webBkRoutingComs = [];
        var newArr = row.routeList.map(function (item, index) {
          return {
            tripNumber: _this16.form.webBkRoutingComs.length + index + 1,
            lineType: Number(item.lineType),
            serviceLineCode: item.serviceLineCode,
            vesselCode: item.vesselCode,
            vesselName: item.vesselName,
            voyageNo: item.voyageNo,
            voyageLeg: item.voyageLeg,
            portFrom: item.polCode,
            portFromName: item.pol,
            portToName: item.pod,
            portTo: item.podCode,
            etd: (0, _utils.parseTime)(item.etd, '{y}-{m}-{d} {h}:{i}:{s}'),
            eta: item.eta,
            carrier: item.carrier
          };
        });
        this.form.webBkRoutingComs = [].concat((0, _toConsumableArray2.default)(this.form.webBkRoutingComs), (0, _toConsumableArray2.default)(newArr));
        this.loading.close();
      } else {
        var data = {};
        this.form.webBkRoutingComs = [];
        data.vesselCode = row.vesselCode;
        data.vesselName = row.vesselName;
        data.voyageNo = row.voyageNo;
        data.voyageLeg = row.voyageLeg;
        data.serviceLineCode = row.serviceLineCode;
        data.tripNumber = this.form.webBkRoutingComs.length + 1;
        data.portFrom = row.polHidden;
        data.portTo = row.podHidden;
        data.portFromName = row.pol;
        data.portToName = row.pod;
        data.etd = row.etd;
        data.eta = row.eta;
        data.carrier = row.carrier;
        data.lineType = Number(row.lineType);
        console.log(data, '000000000');
        this.form.webBkRoutingComs.push(data);
        this.loading.close();
      }
      if (!(0, _validate.validateNull)(chargeDetails) && this.isCopy === 'copy') {
        this.chargeInfo = chargeDetails;
        if (this.chargeInfo === 'NoCharge') {
          this.navTabList.push({
            name: '运价信息',
            nameEn: 'Freight rate'
          });
          var dataQuery = {
            serviceLineCode: row.serviceLineCode,
            voyageLeg: row.voyageLeg,
            pol: row.polHidden,
            etd: row.polEtdStr
          };
          (0, _booking.checkQueryPriceType)(dataQuery).then(function (response) {
            _this16.chargeTypeInfo = response.data;
          });
        } else {
          this.form.webBkChargeDetailComs = this.chargeInfo.filter(function (item) {
            return item.containerType === '20GP' || item.containerType === '40GP' || item.containerType === '40HC';
          });
          if (!(0, _validate.validateNull)(this.form.webBkChargeDetailComs)) {
            this.navTabList.push({
              name: '运价信息',
              nameEn: 'Freight rate'
            });
            var _dataQuery = {
              serviceLineCode: row.serviceLineCode,
              voyageLeg: row.voyageLeg,
              pol: row.polHidden,
              etd: row.polEtdStr
            };
            (0, _booking.checkQueryPriceType)(_dataQuery).then(function (response) {
              _this16.chargeTypeInfo = response.data;
            });
          }
        }
      }
    },
    handAddVesselInfo: function handAddVesselInfo(index) {
      this.currentIndex = index;
      this.sailScheduleDialogVisible = true;
    },
    // 获取包装类型
    queryListPackageType: function queryListPackageType() {
      var _this17 = this;
      var data = {
        pageSize: 1000,
        currentPage: 1
      };
      (0, _booking.queryListPackageType)(data).then(function (res) {
        _this17.packageTypeList = res.data.records || [];
      });
      (0, _booking.queryListCode)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, data), {}, {
        type: "SERVICE_MODE"
      })).then(function (res) {
        _this17.transportationTermsList = res.data || [];
      });
      (0, _booking.queryListCodeName)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, data), {}, {
        type: "CARGO_TYPE"
      })).then(function (res) {
        _this17.cargoList = res.data || [];
      });
      (0, _booking.queryListCode)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, data), {}, {
        type: "EQUIPMENT"
      })).then(function (res) {
        _this17.containerTypeList = res.data || [];
      });
    },
    selectTab: function selectTab(index) {
      this.selectedIndex = index;
      this.changeScroll(index);
    },
    changeScroll: function changeScroll(index) {
      var datamap = {
        0: 'basicInfo',
        1: 'consignerInfo',
        2: 'cargoInfo',
        3: 'boxInfo',
        4: 'otherInfo',
        5: 'chargeInfo'
      };
      var offsetTop = document.getElementById(datamap[index]).offsetTop;
      console.log(offsetTop, 'targetPosition');
      this.$refs.scrollMain.scrollTop = offsetTop - 50;
    },
    handleSetDelteList: function handleSetDelteList() {
      this.form.deleteWebFeeItemComs = []; //附加费和杂费
      this.form.deleteWebBkDocumentComs = []; // BK document
      this.form.deleteWebBkPreContainerComs = []; // 下货箱信息
      this.form.deleteWebBkRoutingComs = []; // 中转
      this.form.deleteWebBkImoComs = []; // imo
      this.form.deleteWebBkReeferComs = []; // 冷箱
      this.form.deleteWebBkAkComs = []; // 特种箱
      this.form.deleteWebBkSocComs = []; // soc
      this.form.deleteWebBkHgComs = []; // 特种箱
    },
    //  中转数据处理
    handleTransferNew: function handleTransferNew() {
      var _this18 = this;
      if (this.bookingInfo.isTs === '0') {
        var data = {
          tripNumber: 1,
          lineType: Number(this.bookingInfo.lineType),
          serviceLineCode: this.bookingInfo.serviceLineCode,
          vesselCode: this.bookingInfo.vesselCode,
          vesselName: this.bookingInfo.vesselName,
          voyageNo: this.bookingInfo.voyageNo,
          voyageLeg: this.bookingInfo.voyageLeg,
          portFrom: this.bookingInfo.polHidden,
          portTo: this.bookingInfo.podHidden,
          etd: this.bookingInfo.polEtdStr && (0, _utils.parseTime)(this.bookingInfo.etd, '{y}-{m}-{d} {h}:{i}:{s}'),
          eta: this.bookingInfo.eta,
          carrier: this.bookingInfo.carrier,
          portFromName: this.bookingInfo.pol,
          portToName: this.bookingInfo.pod
        };
        console.log('this.form.webBkRoutingComs', data);
        this.form.webBkRoutingComs.push(data);
      }
      if (this.bookingInfo.isTs === '1') {
        this.form.tsFlag = 1;
        console.log(this.bookingInfo, 'this.bookingInfo.routeList');
        this.form.webBkRoutingComs = this.bookingInfo.routeList.map(function (item, index) {
          return {
            tripNumber: index + 1,
            lineType: Number(item.lineType),
            serviceLineCode: item.serviceLineCode,
            vesselCode: item.vesselCode,
            vesselName: item.vesselName,
            voyageNo: item.voyageNo,
            voyageLeg: item.voyageLeg,
            portFrom: item.polCode,
            portTo: item.podCode,
            portFromName: item.pol,
            portToName: item.pod,
            etd: _this18.bookingInfo.polEtdStr && (0, _utils.parseTime)(item.etd, '{y}-{m}-{d} {h}:{i}:{s}'),
            eta: item.eta,
            carrier: item.carrier
          };
        });
      }
    },
    handleInit: function handleInit() {
      var _this19 = this;
      this.handleSetDelteList();
      //  this.vessNameVoy = this.bookingInfo.vesselCode + '.' + this.bookingInfo.voyageNo + ' ' +  this.bookingInfo.voyageLeg
      this.form.saillingDate = this.bookingInfo.polEtdStr;
      this.form.etd = this.bookingInfo.polEtdStr && (0, _utils.parseTime)(this.bookingInfo.polEtdStr, '{y}-{m}-{d} {h}:{i}:{s}');
      this.form.eta = this.bookingInfo.podEtaStr;
      this.form.por = this.bookingInfo.polHidden;
      this.form.pol = this.bookingInfo.polHidden;
      this.form.del = this.bookingInfo.podHidden;
      this.form.pod = this.bookingInfo.podHidden;
      this.form.polName = this.bookingInfo.pol;
      this.form.delName = this.bookingInfo.pod;
      this.form.podName = this.bookingInfo.pod;
      this.form.porName = this.bookingInfo.pol;
      if (this.chargeInfo === 'NoCharge') {
        this.navTabList.push({
          name: '运价信息',
          nameEn: 'Freight rate'
        });
        var dataQuery = {
          serviceLineCode: this.bookingInfo.serviceLineCode,
          voyageLeg: this.bookingInfo.voyageLeg,
          pol: this.bookingInfo.polHidden,
          etd: this.bookingInfo.polEtdStr
        };
        (0, _booking.checkQueryPriceType)(dataQuery).then(function (response) {
          _this19.chargeTypeInfo = response.data;
        });
      } else if (!(0, _validate.validateNull)(this.chargeInfo)) {
        this.form.webBkChargeDetailComs = this.chargeInfo.filter(function (item) {
          return item.containerType === '20GP' || item.containerType === '40GP' || item.containerType === '40HC';
        });
        if (!(0, _validate.validateNull)(this.form.webBkChargeDetailComs)) {
          this.navTabList.push({
            name: '运价信息',
            nameEn: 'Freight rate'
          });
          var _dataQuery2 = {
            serviceLineCode: this.bookingInfo.serviceLineCode,
            voyageLeg: this.bookingInfo.voyageLeg,
            pol: this.bookingInfo.polHidden,
            etd: this.bookingInfo.polEtdStr
          };
          (0, _booking.checkQueryPriceType)(_dataQuery2).then(function (response) {
            _this19.chargeTypeInfo = response.data;
          });
        }
      }
      //  this.form.vesselCode = this.bookingInfo.vesselCode
      //  this.form.vesselName = this.bookingInfo.vesselName
      //  this.form.voyageLeg = this.bookingInfo.voyageLeg
      //  this.form.serviceLineCode = this.bookingInfo.serviceLineCode
      //  this.form.voyageNo = this.bookingInfo.voyageNo
      this.form.paidPalce = this.bookingInfo.polHidden;
      this.form.etaPol = this.bookingInfo.polEtaStr;
      if (this.bookingInfo && this.bookingInfo.extend) {
        this.form.singleContainerFlag = 1;
      }
      console.log(this.userInfo, 'this.userInfo');
      if (this.form.pol && this.form.pol.startsWith('TH')) {
        this.handleShowDisplay();
      }
      this.handleTransferNew();
      this.handleSetMessage();
      this.isShowContent = false;
      this.showCargoInfo = true; //防止一些界面显示不出来，兜底设置为true
    },
    handleAddTerminalInfo: function handleAddTerminalInfo() {
      if (this.form.webBkYardComs.length <= 0) {
        var data = {
          pickupYard: '',
          returnYard: '',
          pickupDate: '',
          rowStatus: 4
        };
        this.form.webBkYardComs.push(data);
      }
    },
    handleAddBox: function handleAddBox() {
      var data = {
        containerType: '',
        quantity: this.form.singleContainerFlag == 1 ? 1 : null,
        cargoTypeCode: '',
        pickUpDate: '',
        returnDate: '',
        pickUpDepot: '',
        returnDepot: '',
        id: '',
        rowStatus: 4
      };
      this.form.webBkPreContainerComs.push(data);
    },
    handleClear: function handleClear() {},
    handleRemoveBox: function handleRemoveBox(row, index) {
      if (row.bookingHeadWebComId) {
        row.rowStatus = 8;
        this.form.deleteWebBkPreContainerComs.push(row);
      }
      this.form.webBkPreContainerComs.splice(index, 1);
    },
    handleAddCharge: function handleAddCharge() {
      var data = {
        feeItem: '',
        payModel: '',
        id: '',
        rowStatus: 4
      };
      this.form.webFeeItemComs.push(data);
    },
    handleRemoveCharge: function handleRemoveCharge(row, index) {
      if (row.bookingHeadWebComId) {
        row.rowStatus = 8;
        this.form.deleteWebFeeItemComs.push(row);
      }
      this.form.webFeeItemComs.splice(index, 1);
    },
    handleAddChargeBk: function handleAddChargeBk() {
      var data = {
        documentNo: '',
        packageCount: null,
        packageType: '',
        weight: null,
        isSplit: '',
        useTimes: null,
        id: '',
        rowStatus: 4
      };
      this.form.webBkDocumentComs.push(data);
    },
    handleRemoveBk: function handleRemoveBk(row, index) {
      if (row.bookingHeadWebComId) {
        row.rowStatus = 8;
        this.form.deleteWebBkDocumentComs.push(row);
      }
      this.form.webBkDocumentComs.splice(index, 1);
    },
    handleSelect: function handleSelect() {
      // this.$emit('handleSelect',this.form)
      this.submitForm();
    },
    //  判断中转的序号不能为空
    handleIsNull: function handleIsNull() {
      // 检查是否有空的 number 字段
      for (var i = 0; i < this.form.webBkRoutingComs.length; i++) {
        console.log(this.form.webBkRoutingComs[i].tripNumber, 'this.form.webBkRoutingComs[i].tripNumber');
        if (!this.form.webBkRoutingComs[i].tripNumber) {
          return false; // 如果有空的 number 字段，直接返回 false
        }
        return true; // 如果没有空的 number 字段，返回 true
      }
    },
    //  判断序号是不是连续的
    handleTransNumber: function handleTransNumber() {
      var numbers = this.form.webBkRoutingComs.map(function (item) {
        return Number(item.tripNumber);
      });
      numbers.sort(function (a, b) {
        return a - b;
      });
      // 检查相邻元素是否连续
      for (var i = 1; i < numbers.length; i++) {
        if (numbers[i] !== numbers[i - 1] + 1) {
          return false; // 如果不连续，返回 false
        }
      }
      return true;
    },
    findDuplicatesWithIndices: function findDuplicatesWithIndices(arr) {
      var elementMap = new Map();
      var duplicates = {};
      for (var i = 0; i < arr.length; i++) {
        var element = arr[i];
        if (!elementMap.has(element)) {
          elementMap.set(element, {
            count: 1,
            indices: i
          });
        } else {
          var _elementMap$get = elementMap.get(element),
            count = _elementMap$get.count,
            indices = _elementMap$get.indices;
          elementMap.set(element, {
            count: count + 1,
            indices: Math.max(indices, i)
          });

          // If the element is a duplicate (count > 1), store it in duplicates object
          if (count === 1) {
            duplicates[element] = [];
          }
          duplicates[element].push(i);
        }
      }
      // Filter out elements that are not duplicates (count <= 1)
      var result = {};
      var _iterator = (0, _createForOfIteratorHelper2.default)(elementMap),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = (0, _slicedToArray2.default)(_step.value, 2),
            _element = _step$value[0],
            _step$value$ = _step$value[1],
            _count = _step$value$.count,
            _indices = _step$value$.indices;
          if (_count > 1) {
            result[_element] = _indices;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return result;
    },
    handleValid: function handleValid() {
      if (this.form.pol && this.form.pol.startsWith('TH')) {
        var _iterator2 = (0, _createForOfIteratorHelper2.default)(this.form.webBkCustomerComs),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var ele = _step2.value;
            var _iterator3 = (0, _createForOfIteratorHelper2.default)(ele.webBkCusCatalogComs),
              _step3;
            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var item = _step3.value;
                if (ele.customerType === 0 && item.sequence === '1' && !item.catalogContent) {
                  this.$message({
                    message: this.$t('home.customerTypeOne'),
                    type: 'warning'
                  });
                  return false;
                }
                if (ele.customerType === 1 && item.sequence === '1' && !item.catalogContent) {
                  this.$message({
                    message: this.$t('home.customerTypeTwo'),
                    type: 'warning'
                  });
                  return false;
                }
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
      if (this.form.pol && this.form.pol.startsWith('MY') && !this.form.hsCodeCn) {
        this.$message({
          message: this.$t('home.hsCodeFour'),
          type: 'warning'
        });
        return false;
      }
      // 进行拷贝的时候一定要进行船期选择
      if (!this.form.vesselCode || !this.form.voyageNo) {
        this.$message({
          message: this.$t('home.toastEleven'),
          type: 'warning'
        });
        return false;
      }
      // 没有勾选中转，中转数据不能大于2条
      if (this.form.tsFlag === 0 && this.form.webBkRoutingComs.length > 1) {
        this.$message({
          message: this.$t('home.toastTen'),
          type: 'warning'
        });
        return false;
      }
      // 勾选中转，中转数据至少有两条
      if (this.form.tsFlag === 1 && this.form.webBkRoutingComs.length < 2) {
        this.$message({
          message: this.$t('home.tsPlus'),
          type: 'warning'
        });
        return false;
      }
      //当运价信息存在，下货纸只能保存运价信息里面的箱型
      if (!(0, _validate.validateNull)(this.form.webBkChargeDetailComs)) {
        var chargeContainerType = this.form.webBkChargeDetailComs.map(function (it) {
          return it.containerType;
        });
        var findNotCharge = this.form.webBkPreContainerComs.some(function (item) {
          return !chargeContainerType.includes(item.containerType);
        });
        if (findNotCharge) {
          this.$message({
            message: this.$t('home.containerTypeNotTrue'),
            type: 'warning'
          });
          return false;
        }
      }
      //新增时当模式为单票上限的时候保存箱量不大于最大箱量,单票单箱下货纸只能存在一条信息
      if (!(0, _validate.validateNull)(this.chargeTypeInfo)) {
        if (this.chargeTypeInfo.singleContainerFlag === 1) {
          if (this.form.webBkPreContainerComs.length > 1) {
            this.$message({
              message: this.$t('home.containerLimitNotTrueSingle'),
              type: 'warning'
            });
            return false;
          }
        } else {
          var maxNum = this.chargeTypeInfo.maxTeusLimit === null || this.chargeTypeInfo.maxTeusLimit === 0 ? null : this.chargeTypeInfo.maxTeusLimit;
          if (maxNum !== null) {
            var containerNum = this.form.webBkPreContainerComs.reduce(function (accumulator, item) {
              var actualNum = item.containerType.indexOf('20') !== -1 ? 1 : item.containerType.indexOf('40') !== -1 ? 2 : item.containerType.indexOf('45') !== -1 ? 2.5 : 0;
              return accumulator + actualNum * item.quantity;
            }, 0);
            if (containerNum > maxNum) {
              this.$message({
                message: this.$t('home.containerLimitNotTrue') + this.chargeTypeInfo.maxTeusLimit,
                type: 'warning'
              });
              return false;
            }
          }
        }
      }
      //修改时当模式为单票上限的时候保存箱量不大于最大箱量
      if (!(0, _validate.validateNull)(this.form.webBkExtendComs) && this.form.webBkExtendComs[0].singleContainerFlag === 1) {
        if (this.form.webBkExtendComs[0].singleFlag === 1) {
          if (this.form.webBkPreContainerComs.length > 1) {
            this.$message({
              message: this.$t('home.containerLimitNotTrueSingle'),
              type: 'warning'
            });
            return false;
          }
        } else {
          var _maxNum = this.form.webBkExtendComs[0].singleFlag === 1 ? 1 : this.form.webBkExtendComs[0].maxTeusLimit === null || this.form.webBkExtendComs[0].maxTeusLimit === 0 ? null : this.form.webBkExtendComs[0].maxTeusLimit;
          if (_maxNum !== null) {
            var _containerNum = this.form.webBkPreContainerComs.reduce(function (accumulator, item) {
              var actualNum = item.containerType.indexOf('20') !== -1 ? 1 : item.containerType.indexOf('40') !== -1 ? 2 : item.containerType.indexOf('45') !== -1 ? 2.5 : 0;
              return accumulator + actualNum * item.quantity;
            }, 0);
            if (_containerNum > _maxNum) {
              this.$message({
                message: this.$t('home.containerLimitNotTrue') + this.form.webBkExtendComs[0].maxTeusLimit,
                type: 'warning'
              });
              return false;
            }
          }
        }
      }
      if (!this.handleTransNumber()) {
        this.$message({
          message: this.$t('home.toastNumber'),
          type: 'warning'
        });
        return false;
      }
      // 判断中转的序号不能为空
      if (!this.handleIsNull()) {
        this.$message({
          message: this.$t('home.toastNumberOne'),
          type: 'warning'
        });
        return false;
      }
      if (this.form.pol === 'CNTAO') {
        var row = this.form.webBkYardComs[0];
        if (!row.pickupYard || !row.returnYard) {
          this.$message({
            message: this.$t('home.terminalInfoMessage'),
            type: 'warning'
          });
          return false;
        }
      }
      // 下货箱信息箱型，货类，需与勾选特殊设置一致。
      if (this.form.webBkPreContainerComs.length > 0) {
        var font3 = this.checkArray(this.form.webBkPreContainerComs);
        if (!font3) {
          this.$message({
            message: this.$t('home.toastOneFont'),
            type: 'warning'
          });
          return false;
        }
        //货类为单挂衣/双挂衣,需勾选挂衣箱正反校验
        var found = this.form.webBkPreContainerComs.some(function (item) {
          return item.cargoTypeCode === '0005' || item.cargoTypeCode === '0006';
        });
        if (found && this.form.webBkHgComs.length === 0) {
          this.$message({
            message: this.$t('home.toastOne'),
            type: 'warning'
          });
          return false;
        }
        if (!found && this.form.hgCheckFlag && this.form.webBkHgComs.length > 0) {
          this.$message({
            message: this.$t('home.toastOne_1'),
            type: 'warning'
          });
          return false;
        }
        //箱型为FR/OT/OH/FH,需勾选特种箱信息正反校验
        var foundOne = this.form.webBkPreContainerComs.some(function (item) {
          return item.containerType.includes('FR') || item.containerType.includes('OT') || item.containerType.includes('OH') || item.containerType.includes('FH');
        });
        if (foundOne && this.form.webBkAkComs.length === 0) {
          this.$message({
            message: this.$t('home.toastTwo'),
            type: 'warning'
          });
          return false;
        }
        if (!foundOne && this.form.akCheckFlag && this.form.webBkAkComs.length > 0) {
          this.$message({
            message: this.$t('home.toastTwo_1'),
            type: 'warning'
          });
          return false;
        }
        //危险品,需勾选危险品，正反校验
        var foundTwo = this.form.webBkPreContainerComs.some(function (item) {
          return item.cargoTypeCode === '0003' || item.cargoTypeCode === '0004' || item.cargoTypeCode === '0022';
        });
        if (foundTwo && this.form.webBkImoComs.length === 0) {
          this.$message({
            message: this.$t('home.toastThree'),
            type: 'warning'
          });
          return false;
        }
        if (!foundTwo && this.form.dgCheckFlag && this.form.webBkImoComs.length > 0) {
          this.$message({
            message: this.$t('home.toastThree_1'),
            type: 'warning'
          });
          return false;
        }
        // 冻货需勾选冷箱，正反校验
        var foundThree = this.form.webBkPreContainerComs.some(function (item) {
          return item.cargoTypeCode === '0002';
        });
        if (foundThree && this.form.webBkReeferComs.length === 0) {
          this.$message({
            message: this.$t('home.toastFour'),
            type: 'warning'
          });
          return false;
        }
        if (!foundThree && !foundOne && !foundTwo && this.form.rfCheckFlag && this.form.webBkReeferComs.length > 0) {
          this.$message({
            message: this.$t('home.toastFour_1'),
            type: 'warning'
          });
          return false;
        }
        var preContainerType = this.form.webBkPreContainerComs.map(function (item) {
          return item.containerType;
        });
        //特种箱的箱型是得下货纸存在的箱型
        if (this.form.akCheckFlag && this.form.webBkAkComs.length > 0) {
          var _iterator4 = (0, _createForOfIteratorHelper2.default)(this.form.webBkAkComs),
            _step4;
          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var _item = _step4.value;
              if (!preContainerType.includes(_item.containerType)) {
                this.$message({
                  message: this.$t('home.toast0'),
                  type: 'warning'
                });
                return false;
              }
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
        }
        //挂衣箱的箱型是得下货纸存在的箱型
        if (this.form.hgCheckFlag && this.form.webBkHgComs.length > 0) {
          var _iterator5 = (0, _createForOfIteratorHelper2.default)(this.form.webBkHgComs),
            _step5;
          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var _item2 = _step5.value;
              if (!preContainerType.includes(_item2.containerType)) {
                this.$message({
                  message: this.$t('home.toast1'),
                  type: 'warning'
                });
                return false;
              }
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }
        }
        //  const foundFour = this.form.webBkPreContainerComs.some(item => item.cargoTypeCode==='0002' );
        //  const foundSix = this.form.webBkPreContainerComs.some(item => item.containerType.includes('HR') || item.containerType.includes('RF'));
        var _iterator6 = (0, _createForOfIteratorHelper2.default)(this.form.webBkPreContainerComs),
          _step6;
        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var _item3 = _step6.value;
            if (_item3.cargoTypeCode === '0002') {
              if (!(_item3.containerType.includes('HR') || _item3.containerType.includes('RF'))) {
                this.$message({
                  message: this.$t('home.toastFive'),
                  type: 'warning'
                });
                return false;
              }
            }
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
      }
      if (this.form.webFeeItemComs) {
        var _iterator7 = (0, _createForOfIteratorHelper2.default)(this.form.webFeeItemComs),
          _step7;
        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var _item4 = _step7.value;
            if (!String(_item4.payModel) || !_item4.feeItem) {
              this.$message({
                message: this.$t('home.toastSix'),
                type: 'warning'
              });
              return false;
            }
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }
      }
      // if(this.bookingInfo && this.bookingInfo.extend && this.bookingInfo.slotControlStatus == "1"){
      //     if(this.form.webBkPreContainerComs.length>1){
      //         this.$message({
      //             message: this.$t('home.toastSeven'),
      //             type: 'warning'
      //         })
      //         return false
      //     }
      //     if(this.form.webBkPreContainerComs[0].quantity!==1){
      //         this.$message({
      //             message: this.$t('home.toastEight'),
      //             type: 'warning'
      //         })
      //         return false
      //     }
      //
      // }
      if (this.form.webBkImoComs.length > 0) {
        var _iterator8 = (0, _createForOfIteratorHelper2.default)(this.form.webBkImoComs),
          _step8;
        try {
          for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
            var _item5 = _step8.value;
            if (_item5.classType && _item5.classType.startsWith("3")) {
              console.log(_item5.flashPoint, 'item.flashPoint', _item5.rateBase);
              if (_item5.flashPoint !== 0 && !_item5.flashPoint || !_item5.rateBase) {
                this.$message({
                  message: this.$t('home.dangerousGoodsMessage'),
                  type: 'warning'
                });
                return false;
              }
            }
          }
          // this.form.webBkImoComs.forEach(item => {
          //     if (item.classType&&(item.classType).startsWith("3")) {
          //         if(!item.flashPoint && !item.flashPoint || !item.rateBase)
          //         this.$message({
          //             message: this.$t('home.dangerousGoodsMessage'),
          //             type: 'warning'
          //         })
          //         return false
          //     }
          // })
        } catch (err) {
          _iterator8.e(err);
        } finally {
          _iterator8.f();
        }
      }
      return true;
    },
    //  下货纸信息重复，除数量外
    checkArray: function checkArray(arr) {
      if (!Array.isArray(arr) || arr.length < 2) {
        return true;
      }
      var propertiesToCompare = ['containerType', 'cargoTypeCode', 'pickUpDate', 'returnDate', 'pickUpDepot', 'returnDepot'];
      var array = this.form.webBkPreContainerComs;
      var allUnique = !array.some(function (item1, i) {
        return array.slice(i + 1).some(function (item2) {
          return propertiesToCompare.every(function (prop) {
            var val1 = item1[prop] === null ? '' : String(item1[prop]);
            var val2 = item2[prop] === null ? '' : String(item2[prop]);
            return val1 === val2;
          });
        });
      });
      return allUnique;
    },
    //  处理被删除的数据
    handSetData: function handSetData(form) {
      // 下货纸箱
      form.webBkPreContainerComs = [].concat((0, _toConsumableArray2.default)(form.webBkPreContainerComs), (0, _toConsumableArray2.default)(form.deleteWebBkPreContainerComs));
      delete form.deleteWebBkPreContainerComs;
      // 附加费杂费
      form.webFeeItemComs = [].concat((0, _toConsumableArray2.default)(form.webFeeItemComs), (0, _toConsumableArray2.default)(form.deleteWebFeeItemComs));
      delete form.deleteWebFeeItemComs;
      // BK document
      form.webBkDocumentComs = [].concat((0, _toConsumableArray2.default)(form.webBkDocumentComs), (0, _toConsumableArray2.default)(form.deleteWebBkDocumentComs));
      delete form.deleteWebBkDocumentComs;
      // 中转
      form.webBkRoutingComs = [].concat((0, _toConsumableArray2.default)(form.webBkRoutingComs), (0, _toConsumableArray2.default)(form.deleteWebBkRoutingComs));
      delete form.deleteWebBkRoutingComs;
      // 危险品
      console.log(form.webBkImoComs, 'form.webBkImoComs', form.deleteWebBkImoComs);
      form.webBkImoComs = [].concat((0, _toConsumableArray2.default)(form.webBkImoComs), (0, _toConsumableArray2.default)(form.deleteWebBkImoComs));
      console.log(form.webBkImoComs, 'form.deleteWebBkReeferComs00000');
      delete form.deleteWebBkImoComs;
      // 冷箱

      form.webBkReeferComs = [].concat((0, _toConsumableArray2.default)(form.webBkReeferComs), (0, _toConsumableArray2.default)(form.deleteWebBkReeferComs));
      delete form.deleteWebBkReeferComs;
      // 特种箱
      form.webBkAkComs = [].concat((0, _toConsumableArray2.default)(form.webBkAkComs), (0, _toConsumableArray2.default)(form.deleteWebBkAkComs));
      delete form.deleteWebBkAkComs;
      // soc
      form.webBkSocComs = [].concat((0, _toConsumableArray2.default)(form.webBkSocComs), (0, _toConsumableArray2.default)(form.deleteWebBkSocComs));
      delete form.deleteWebBkSocComs;
      // 挂衣箱
      form.webBkHgComs = [].concat((0, _toConsumableArray2.default)(form.webBkHgComs), (0, _toConsumableArray2.default)(form.deleteWebBkHgComs));
      delete form.deleteWebBkHgComs;
      return form;
    },
    // 拷贝的时候四大港口的处理
    handleTranfPort: function handleTranfPort() {},
    // 保存
    handleSave: function () {
      var _handleSave = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(row) {
        var _this20 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (this.flag) {
                this.$refs.form.validate( /*#__PURE__*/function () {
                  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(valid) {
                    var checkPol, checkCargoDesc, nowArray, myMap, checkValidateFeeInfoFlag, commodityCode, form, newForm;
                    return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
                      while (1) switch (_context.prev = _context.next) {
                        case 0:
                          if (!valid) {
                            _context.next = 40;
                            break;
                          }
                          _this20.loading = (0, _utils.load)();
                          _context.next = 4;
                          return _this20.$store.dispatch('isSaveTip/checkPol', _this20.form.pol);
                        case 4:
                          checkPol = _context.sent;
                          if (checkPol) {
                            _context.next = 9;
                            break;
                          }
                          _this20.language === 'en' ? _this20.$message.error("This account does not have".concat(_this20.form.pol, "booking rights")) : _this20.$message.error("\u8BE5\u8D26\u53F7\u6CA1\u6709".concat(_this20.form.pol, "\u7684\u8BA2\u8231\u6743\u9650"));
                          _this20.loading.close();
                          return _context.abrupt("return");
                        case 9:
                          console.log(_this20.flag, ' this.flag');
                          _context.next = 12;
                          return _this20.$store.dispatch("isSaveTip/checkValidateCargoDesc", _this20.form);
                        case 12:
                          checkCargoDesc = _context.sent;
                          if (checkCargoDesc) {
                            _context.next = 16;
                            break;
                          }
                          _this20.loading.close();
                          return _context.abrupt("return");
                        case 16:
                          nowArray = _this20.form.webFeeItemComs.map(function (item) {
                            return item.feeItem;
                          });
                          if (!(nowArray.length !== new Set(nowArray).size)) {
                            _context.next = 22;
                            break;
                          }
                          myMap = _this20.findDuplicatesWithIndices(nowArray);
                          _this20.$confirm(_this20.$t('home.validateFee1') + (Object.values(myMap)[0] + 1) + _this20.$t('home.validateFee2') + Object.keys(myMap)[0] + _this20.$t('home.validateFee3'), _this20.$t('confirmMsg.title'), {
                            confirmButtonText: _this20.$t('confirmMsg.submit'),
                            cancelButtonText: _this20.$t('confirmMsg.cancel'),
                            type: 'warning'
                          });
                          _this20.loading.close();
                          return _context.abrupt("return");
                        case 22:
                          _context.next = 24;
                          return _this20.$store.dispatch("isSaveTip/checkValidateFeeInfo", _this20.form);
                        case 24:
                          checkValidateFeeInfoFlag = _context.sent;
                          if (!checkValidateFeeInfoFlag) {
                            _context.next = 28;
                            break;
                          }
                          _this20.loading.close();
                          return _context.abrupt("return");
                        case 28:
                          _this20.$refs.bookInfo.handleGetFileList();
                          if (!_this20.form.bookingHeadWebComId) {
                            // this.form.status = row
                            _this20.form.webBkExtendComs = [{
                              porName: _this20.form.porName,
                              //接货地描述
                              polName: _this20.form.polName,
                              //装货港描述
                              podName: _this20.form.podName,
                              //卸货港描述
                              delName: _this20.form.delName,
                              //	目的地描述
                              bookingFwdPerson: _this20.form.bookingFwdPerson || '',
                              //当前用户code
                              bookingFwdTel: _this20.form.bookingFwdTel || '',
                              //当前用户电话
                              bookingFwdEmail: _this20.form.bookingFwdEmail || '',
                              //当前用户邮箱
                              bookingFwdFax: '',
                              //当前用户传真
                              rowStatus: 4,
                              singleContainerFlag: _this20.form.singleContainerFlag
                              // singleContainerFlag:this.bookingInfo.extend && this.bookingInfo.slotControlStatus || '',
                            }], console.log(_this20.form.webBkExtendComs, _this20.form.singleContainerFlag, 'this.form0000');
                            // 处理冷箱和危险品具体后端要求的结构形式
                            //处理货物信息的问题品名代码的问题
                            commodityCode = _this20.form.webBkCargoComs[0].commodityCode;
                            _this20.form.webBkCargoComs = [{
                              commodityCode: commodityCode,
                              webBkImoComs: _this20.form.webBkImoComs,
                              webBkReeferComs: _this20.form.webBkReeferComs,
                              packageType: 'PKGS',
                              packageDesc: 'PACKAGE(S)',
                              cargoQuantity: 0,
                              cargoSize: 0,
                              shippingMark: 'N/M',
                              rowStatus: 4
                            }];
                          } else {
                            _this20.form.webBkExtendComs[0].bookingFwdPerson = _this20.form.bookingFwdPerson || '';
                            _this20.form.webBkExtendComs[0].bookingFwdTel = _this20.form.bookingFwdTel || '';
                            _this20.form.webBkExtendComs[0].bookingFwdEmail = _this20.form.bookingFwdEmail || '';
                            console.log(row, _this20.form.status, 'this.form.bookingFwdPerson');
                          }
                          //去掉hsCode同步
                          // if(!this.form.hsCode){
                          //     this.form.hsCode = this.form.hsCodeCn || this.form.hsCodeJp
                          // }
                          // if(!this.form.hsCodeCn){
                          //     this.form.hsCodeCn = this.form.hsCode || this.form.hsCodeJp
                          // }
                          // if(!this.form.hsCodeJp){
                          //     this.form.hsCodeJp = this.form.hsCode || this.form.hsCodeCn
                          // }
                          form = JSON.parse(JSON.stringify(_this20.form));
                          newForm = _this20.handSetData(form);
                          if (row === 11 && (_this20.form.status === '10' || !_this20.form.status)) {
                            newForm.status = 11; //如果是草稿改成申请状态
                          }
                          if (row === 10 && !_this20.form.status) {
                            newForm.status = 10; //如果是null改为草稿状态
                          }
                          if (_this20.isCopy) {
                            newForm.status = row;
                          }
                          if (newForm.bookingHeadWebComId) {
                            // 处理冷箱和危险品具体后端要求的结构形式
                            newForm.webBkCargoComs[0].webBkImoComs = newForm.webBkImoComs;
                            newForm.webBkCargoComs[0].webBkReeferComs = newForm.webBkReeferComs;
                          }
                          // 判断是否是普通订舱还是订舱推广
                          console.log(newForm, 'form0000000000');
                          if (_this20.handleValid()) {
                            _this20.flag = false;
                            (0, _booking.saveWithChild)(newForm).then(function (res) {
                              _this20.$store.dispatch("isSaveTip/isToastSave", false);
                              if (res.success) {
                                //row：11申请状态，10草稿状态
                                if (row === 11) {
                                  // this.$message({
                                  //     message: this.$t('home.saveSuccessSubmit'),
                                  //     type: 'success'
                                  // });
                                  _this20.$confirm(_this20.$t('home.saveSuccessSubmit') + (res.data.bkNo ? '【' + res.data.bkNo + '】' : ''), _this20.$t('confirmMsg.title'), {
                                    confirmButtonText: _this20.$t('confirmMsg.close'),
                                    cancelButtonText: _this20.$t('confirmMsg.close'),
                                    showCancelButton: false,
                                    showClose: false,
                                    closeOnClickModal: false,
                                    type: 'success'
                                  }).then(function () {
                                    //POL = CNSHK  或者 CNNSA  时， 不关闭， 其他情况 自动关闭 跳转到我的订舱页面
                                    if (_this20.form.pol === 'CNSHK' || _this20.form.pol === 'CNNSA') {
                                      _this20.bookingId = res.data.bookingHeadWebComId;
                                      _this20.bookingHeadWebInitProps();
                                      //如果旧数据跟新数据不一样的话，关闭页面会触发保存提示弹窗
                                      _this20.oldData = _this20.newData;
                                      _this20.isCopy = 'Edit';
                                      _this20.$router.push({
                                        path: '/bookingSpace/bookingSpaceDetail',
                                        query: {
                                          id: res.data.bookingHeadWebComId,
                                          type: 'Look'
                                        } // 将 'edit' 替换为你想要的值
                                      });
                                      _this20.isDisable = true;
                                    } else {
                                      _this20.bookingId = res.data.bookingHeadWebComId;
                                      _this20.bookingHeadWebInitProps();
                                      //如果旧数据跟新数据不一样的话，关闭页面会触发保存提示弹窗
                                      _this20.oldData = _this20.newData;
                                      _this20.isCopy = 'Edit';
                                      _this20.$router.push({
                                        path: '/bookingSpace/bookingSpaceDetail',
                                        query: {
                                          id: res.data.bookingHeadWebComId,
                                          type: 'Look'
                                        } // 将 'edit' 替换为你想要的值
                                      });
                                      _this20.isDisable = true;
                                      //如果旧数据跟新数据不一样的话，关闭页面会触发保存提示弹窗
                                      setTimeout(function () {
                                        var data = {
                                          view: _this20.isToastSavePath || _this20.$route
                                        };
                                        //关闭当前路由
                                        _this20.$store.dispatch('tagsView/detailTabDelete', data);
                                        _this20.$router.push({
                                          path: '/bookingSpace/bookingSpaceMy'
                                        });
                                      }, 1000);
                                    }
                                  });
                                } else {
                                  // this.$message({
                                  //     message: this.$t('home.saveSuccess'),
                                  //     type: 'success'
                                  // });
                                  _this20.$confirm(_this20.$t('home.saveSuccess') + (res.data.bkNo ? '【' + res.data.bkNo + '】' : ''), _this20.$t('confirmMsg.title'), {
                                    confirmButtonText: _this20.$t('confirmMsg.close'),
                                    cancelButtonText: _this20.$t('confirmMsg.close'),
                                    showCancelButton: false,
                                    showClose: false,
                                    closeOnClickModal: false,
                                    type: 'success'
                                  }).then(function () {
                                    _this20.bookingId = res.data.bookingHeadWebComId;
                                    _this20.bookingHeadWebInitProps();
                                    //如果旧数据跟新数据不一样的话，关闭页面会触发保存提示弹窗
                                    _this20.oldData = _this20.newData;
                                    _this20.isCopy = 'Edit';
                                    _this20.$router.push({
                                      path: '/bookingSpace/bookingSpaceDetail',
                                      query: {
                                        id: res.data.bookingHeadWebComId,
                                        type: 'Look'
                                      } // 将 'edit' 替换为你想要的值
                                    });
                                    _this20.isDisable = true;
                                  });
                                }
                              }
                            }).catch(function (err) {
                              _this20.clickButton = false;
                            }).finally(function () {
                              _this20.loading.close();
                            });
                          } else {
                            _this20.loading.close();
                          }
                          _context.next = 41;
                          break;
                        case 40:
                          _this20.$nextTick(function () {
                            var errorField = document.querySelector(".is-error");
                            if (errorField) {
                              // 滚动到第一个校验错误的元素
                              errorField.scrollIntoView({
                                behavior: "smooth",
                                block: "center"
                              });
                            }
                          });
                        case 41:
                        case "end":
                          return _context.stop();
                      }
                    }, _callee);
                  }));
                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }());
              }
              setTimeout(function () {
                _this20.flag = true;
              }, 1500);
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function handleSave(_x) {
        return _handleSave.apply(this, arguments);
      }
      return handleSave;
    }(),
    handleCopy: function handleCopy() {
      this.copyId = this.form.bookingHeadWebComId;
      this.copyVisible = true;
      this.copyForm = this.form;
    },
    handleSaveDraft: function handleSaveDraft() {
      this.handleSave(10);
    },
    submitForm: function submitForm() {
      this.$refs.form.validate(function (valid) {
        if (valid) {
          //alert("submit!");
        } else {
          return false;
        }
      });
    },
    // 单证锁船或者舱单锁定或者预配锁定，船名航次调整不可用，订舱明细里面的程次信息不可修改
    getFlagVoyageAdjust: function getFlagVoyageAdjust() {
      var _this21 = this;
      if (this.isCopy === 'copy') {
        this.adjustVesselFlag = null;
        return;
      }
      (0, _booking.validateBkLock)(Object.assign({}, {
        bookingHeadWebIds: this.bookingId
      })).then(function (res) {
        if (res.data) {
          _this21.adjustVesselFlag = true;
        } else {
          _this21.adjustVesselFlag = null;
        }
      });
    }
  }
};